// Breakpoints correspond with _breakpoints.scss
var screenSize = {
    breakpoints: {
        phablet: 680
    },
    isSmallerThan: function(breakpoint) {
        if (!screenSize.hasBreakpoint(breakpoint)) {
            return false;
        }
        return $(window).innerWidth() > screenSize.breakpoints[breakpoint];
    },
    isLargerThan: function(breakpoint) {
        if (!screenSize.hasBreakpoint(breakpoint)) {
            return false;
        }
        return $(window).innerWidth() < screenSize.breakpoints[breakpoint];
    },
    hasBreakpoint: function(breakpoint) {
        return screenSize.breakpoints.hasOwnProperty(breakpoint);
    }
};